import Swal from 'sweetalert2';

const Forms = ( $ ) => {
	$('.file-wrapper input[type="file"]').on('change', function() {
		var ele = this;
		var result = ele.files;
		var $fileName = $(this).next('.file-name');
		$fileName.empty();
		for (var x = 0; x < result.length; x++) {
			var fle = result[x];
			$fileName.append("<span>" + fle.name + " <a href=\"#\"  class=\"remove-file\">&times;</a></span>");
		}
	});

	$(document).on('click', '.file-wrapper .file-name .remove-file', function(e) {
		e.preventDefault();
		e.stopPropagation();
		var $span = $(this).closest('span');
		var index = $span.index();
		var $input = $span.closest('.file-wrapper').find('input[type="file"]');
		var inputEl = $input[0];

		if (inputEl && inputEl.files && window.DataTransfer) {
			var dt = new DataTransfer();
			var files = inputEl.files;
			for (var i = 0; i < files.length; i++) {
				if (i !== index) {
					dt.items.add(files[i]);
				}
			}
			inputEl.files = dt.files;
		}
		$span.remove();
	});
	$( '.request-sample-submit' ).on( 'click', function( e ) {
		e.preventDefault();

		const $button = $( this );
		const $form = $( '.request-sample-form' );
		const $checkboxes = $( 'input[name="sample[]"]:checked' );

		if ( $checkboxes.length === 0 ) {
			Swal.fire({
				title: 'Error!',
				text: 'Please select at least one sample.',
				icon: 'error',
				confirmButtonText: 'OK'
			});
			return;
		}

		const samples = [];
		$checkboxes.each( function() {
			samples.push( $( this ).val() );
		} );

		const data = {
			action: vernayApp.actionCreateSample,
			nonce: vernayApp.nonceCreateSample,
			project_name: $form.find( 'input[name="project_name"]' ).val(),
			delivery_address: $form.find( 'input[name="delivery_address"]' ).val(),
			phone: $form.find( 'input[name="phone"]' ).val(),
			samples: samples
		};

		$button.addClass( 'loading' ).prop( 'disabled', true );

		$.ajax( {
			url: vernayApp.ajaxUrl,
			type: 'POST',
			data: data,
			success: function( response ) {
				if ( response.success ) {
					Swal.fire({
						title: 'Success!',
						text: response.data.message,
						icon: 'success',
						confirmButtonText: 'OK'
					}).then((result) => {
						location.reload();
					});
				} else {
					Swal.fire({
						title: 'Error!',
						text: response.data.message,
						icon: 'error',
						confirmButtonText: 'OK'
					});
				}
			},
			error: function() {
				Swal.fire({
					title: 'Error!',
					text: 'An error occurred. Please try again.',
					icon: 'error',
					confirmButtonText: 'OK'
				});
			},
			complete: function() {
				$button.removeClass( 'loading' ).prop( 'disabled', false );
			}
		} );
	} );

	const addressSelector = 'input#delivery-address, input[name="delivery_address"], #wpforms-1572-field_5, input[name="wpforms[fields][5]"], input[name*="[fields]"][name*="address"], input.delivery-address';

	const initDeliveryAddressAutocomplete = async () => {
		const $inputs = $( addressSelector );
		if ( !$inputs.length ) {
			return;
		}

		const loadGoogleMaps = () => {
			return new Promise( ( resolve ) => {
				if ( typeof google !== 'undefined' && google.maps ) {
					resolve( google.maps );
					return;
				}

				if ( window.vernayApp && window.vernayApp.googleMapsApiKey && !document.querySelector( 'script[src*="maps.googleapis.com"]' ) ) {
					const script = document.createElement( 'script' );
					script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent( window.vernayApp.googleMapsApiKey )}&libraries=places&v=weekly&loading=async`;
					script.async = true;
					script.defer = true;
					script.onload = () => {
						resolve( window.google && window.google.maps ? window.google.maps : null );
					};
					script.onerror = () => resolve( null );
					document.head.appendChild( script );
				} else {
					let attempts = 0;
					const interval = setInterval( () => {
						attempts++;
						if ( typeof google !== 'undefined' && google.maps ) {
							clearInterval( interval );
							resolve( google.maps );
						} else if ( attempts > 25 ) {
							clearInterval( interval );
							resolve( null );
						}
					}, 200 );
				}
			} );
		};

		const maps = await loadGoogleMaps();
		if ( !maps ) {
			return;
		}

		let placesLib = null;
		try {
			if ( maps.importLibrary ) {
				placesLib = await maps.importLibrary( 'places' );
			} else if ( maps.places ) {
				placesLib = maps.places;
			}
		} catch ( e ) {
			placesLib = maps.places || null;
		}

		if ( !placesLib ) {
			return;
		}

		$inputs.each( function() {
			const input = this;
			if ( input.dataset.googleAutocompleteInit ) {
				return;
			}
			input.dataset.googleAutocompleteInit = 'true';

			// Check if Places API (New) AutocompleteSuggestion is supported
			if ( placesLib.AutocompleteSuggestion ) {
				let sessionToken = null;
				let currentSuggestions = [];
				let activeIndex = -1;
				let debounceTimer = null;

				const $dropdown = $( '<div class="vernay-autocomplete-dropdown" style="display:none;"></div>' );
				$( 'body' ).append( $dropdown );

				const updateDropdownPosition = () => {
					const rect = input.getBoundingClientRect();
					$dropdown.css( {
						top: rect.bottom + window.scrollY,
						left: rect.left + window.scrollX,
						width: rect.width,
					} );
				};

				const renderSuggestions = ( suggestions ) => {
					currentSuggestions = suggestions || [];
					activeIndex = -1;
					$dropdown.empty();

					if ( !currentSuggestions.length ) {
						$dropdown.hide();
						return;
					}

					currentSuggestions.forEach( ( item, idx ) => {
						const mainText = item.placePrediction?.mainText?.toString() || item.placePrediction?.text?.toString() || '';
						const secondaryText = item.placePrediction?.secondaryText?.toString() || '';

						const $item = $( `
							<div class="vernay-autocomplete-item" data-index="${idx}">
								<div class="vernay-autocomplete-icon">
									<svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M7 0C3.13 0 0 3.13 0 7C0 12.25 7 18 7 18C7 18 14 12.25 14 7C14 3.13 10.87 0 7 0ZM7 9.5C5.62 9.5 4.5 8.38 4.5 7C4.5 5.62 5.62 4.5 7 4.5C8.38 4.5 9.5 5.62 9.5 7C9.5 8.38 8.38 9.5 7 9.5Z" fill="#342011"/>
									</svg>
								</div>
								<div class="vernay-autocomplete-content">
									<span class="vernay-autocomplete-main">${mainText}</span>
									${secondaryText ? `<span class="vernay-autocomplete-secondary">${secondaryText}</span>` : ''}
								</div>
							</div>
						` );

						$dropdown.append( $item );
					} );

					updateDropdownPosition();
					$dropdown.show();
				};

				const selectSuggestion = async ( index ) => {
					const suggestion = currentSuggestions[ index ];
					if ( !suggestion ) {
						return;
					}

					$dropdown.hide();

					try {
						const place = suggestion.placePrediction.toPlace();
						await place.fetchFields( {
							fields: [ 'formattedAddress', 'displayName', 'addressComponents' ],
						} );
						const address = place.formattedAddress || suggestion.placePrediction.text.toString();
						$( input ).val( address ).trigger( 'change' );
					} catch ( err ) {
						const address = suggestion.placePrediction?.text?.toString() || '';
						if ( address ) {
							$( input ).val( address ).trigger( 'change' );
						}
					}

					sessionToken = null; // Reset session token after completion
				};

				const fetchSuggestions = async ( query ) => {
					if ( !query || query.trim().length < 2 ) {
						$dropdown.hide();
						return;
					}

					if ( !sessionToken && placesLib.AutocompleteSessionToken ) {
						sessionToken = new placesLib.AutocompleteSessionToken();
					}

					try {
						const request = {
							input: query,
						};
						if ( sessionToken ) {
							request.sessionToken = sessionToken;
						}

						const response = await placesLib.AutocompleteSuggestion.fetchAutocompleteSuggestions( request );
						renderSuggestions( response && response.suggestions ? response.suggestions : [] );
					} catch ( err ) {
						console.error( 'Google Places Autocomplete error:', err );
						$dropdown.hide();
					}
				};

				$( input ).on( 'input', function() {
					clearTimeout( debounceTimer );
					const query = $( this ).val();
					debounceTimer = setTimeout( () => {
						fetchSuggestions( query );
					}, 250 );
				} );

				$( input ).on( 'focus', function() {
					if ( currentSuggestions.length && $( this ).val().trim().length >= 2 ) {
						updateDropdownPosition();
						$dropdown.show();
					}
				} );

				$( input ).on( 'keydown', function( e ) {
					const $items = $dropdown.find( '.vernay-autocomplete-item' );
					if ( !$items.length || $dropdown.is( ':hidden' ) ) {
						return;
					}

					if ( e.key === 'ArrowDown' ) {
						e.preventDefault();
						activeIndex = ( activeIndex + 1 ) % $items.length;
						$items.removeClass( 'is-active' ).eq( activeIndex ).addClass( 'is-active' );
					} else if ( e.key === 'ArrowUp' ) {
						e.preventDefault();
						activeIndex = ( activeIndex - 1 + $items.length ) % $items.length;
						$items.removeClass( 'is-active' ).eq( activeIndex ).addClass( 'is-active' );
					} else if ( e.key === 'Enter' ) {
						if ( activeIndex >= 0 && activeIndex < currentSuggestions.length ) {
							e.preventDefault();
							selectSuggestion( activeIndex );
						} else if ( currentSuggestions.length > 0 ) {
							e.preventDefault();
							selectSuggestion( 0 );
						}
					} else if ( e.key === 'Escape' ) {
						$dropdown.hide();
					}
				} );

				$dropdown.on( 'mousedown', '.vernay-autocomplete-item', function( e ) {
					e.preventDefault();
					const idx = parseInt( $( this ).data( 'index' ), 10 );
					selectSuggestion( idx );
				} );

				$( document ).on( 'click', function( e ) {
					if ( !$( e.target ).closest( input ).length && !$( e.target ).closest( $dropdown ).length ) {
						$dropdown.hide();
					}
				} );

				$( window ).on( 'resize scroll', () => {
					if ( $dropdown.is( ':visible' ) ) {
						updateDropdownPosition();
					}
				} );
			} else if ( placesLib.Autocomplete ) {
				// Fallback to Legacy Places Autocomplete if new Places API is not loaded
				const autocomplete = new placesLib.Autocomplete( input, {
					types: [ 'geocode', 'establishment' ],
				} );

				$( input ).on( 'keydown', function( e ) {
					if ( e.key === 'Enter' ) {
						const pacContainer = document.querySelector( '.pac-container' );
						if ( pacContainer && window.getComputedStyle( pacContainer ).display !== 'none' ) {
							e.preventDefault();
						}
					}
				} );

				autocomplete.addListener( 'place_changed', function() {
					const place = autocomplete.getPlace();
					if ( place && place.formatted_address ) {
						$( input ).val( place.formatted_address ).trigger( 'change' );
					}
				} );
			}
		} );
	};

	initDeliveryAddressAutocomplete();
	$( document ).on( 'shown.bs.modal wpformsPageChange wpformsAjaxSubmitSuccess', initDeliveryAddressAutocomplete );
}
export default ( ( $ ) => $( Forms ) )( jQuery );
